var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex w-screen", attrs: { id: "bulk-select-targets" } },
    [
      _c(
        "div",
        {
          staticClass: "relative flex flex-col w-full",
          attrs: { id: "bulk-table" }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-4 px-6 py-4" },
            [
              _c("BlInputSearch", {
                staticClass: "w-80",
                attrs: { input: _vm.searchInput },
                on: { changed: _vm.onInputSearch }
              }),
              _vm._v(" "),
              _c("BlSort", {
                staticClass: "w-60",
                attrs: {
                  options: _vm.sortOptions,
                  defaultValue: { primary: "date", secondary: "desc" }
                },
                on: {
                  change: function($event) {
                    return _vm.onChangeSort($event)
                  }
                },
                model: {
                  value: _vm.sortInput,
                  callback: function($$v) {
                    _vm.sortInput = $$v
                  },
                  expression: "sortInput"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : !_vm.curriculums.length
            ? _c(
                "div",
                {
                  staticClass: "flex flex-col items-center justify-center h-128"
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "text-center",
                    attrs: {
                      text: "Currently, there are no curricula to display."
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "flex flex-col gap-6 px-6 pb-48 overflow-y-auto",
                  style: { height: "calc(100vh - 18.5rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative border rounded border-slate-400" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky top-0 z-10 flex items-center flex-grow-0 w-full bg-slate-300"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 gap-2 px-4 border-r rounded-tl border-slate-400",
                              style: { width: "37.5%" }
                            },
                            [
                              _c("BlInputCheck", {
                                attrs: {
                                  indeterminate:
                                    _vm.checkedCurriculums.length > 0,
                                  checked: _vm.checkedAll
                                },
                                on: {
                                  changed: function($event) {
                                    return _vm.onCheckAllCurriculums()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle3", { attrs: { text: "Name" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4",
                              style: { width: "12.5%" }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: "Number of targets" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 w-6/12 h-12 px-4",
                              style: { width: "50%" }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: "Description" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.curriculums, function(curriculum) {
                        return _c(
                          "div",
                          {
                            key: curriculum.id,
                            staticClass:
                              "flex items-center flex-grow-0 w-full border-b border-slate-400 bg-pure-white"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between flex-shrink-0 h-20 gap-2 px-4 py-3",
                                style: { width: "37.5%" },
                                attrs: { title: curriculum.name }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex gap-2" },
                                  [
                                    _c("BlInputCheck", {
                                      staticClass: "mt-1",
                                      attrs: {
                                        checked: !!_vm.checkedCurriculums.find(
                                          function(i) {
                                            return i.id === curriculum.id
                                          }
                                        ),
                                        disabled: !!_vm.selectedCurriculums.find(
                                          function(i) {
                                            return i.id === curriculum.id
                                          }
                                        )
                                      },
                                      on: {
                                        changed: function($event) {
                                          return _vm.onToggleCheckCurriculum(
                                            curriculum
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "flex-shrink-0 w-4 h-4 mt-1 rounded-full",
                                      style: {
                                        backgroundColor: curriculum.color
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit(
                                              "open-panel",
                                              curriculum
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("BlTextBody1", {
                                          staticClass:
                                            "cursor-pointer line-clamp-2 text-slate-1000 h-13 hover:underline",
                                          attrs: { text: curriculum.name }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    disabled: !!_vm.selectedCurriculums.find(
                                      function(i) {
                                        return i.id === curriculum.id
                                      }
                                    ),
                                    label: !!_vm.selectedCurriculums.find(
                                      function(i) {
                                        return i.id === curriculum.id
                                      }
                                    )
                                      ? "Added"
                                      : "Add"
                                  },
                                  on: {
                                    clicked: function($event) {
                                      return _vm.onAddSelected(curriculum)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-shrink-0 h-20 px-4 py-3",
                                style: { width: "12.5%" }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "line-clamp-2 h-13",
                                  attrs: { text: curriculum.number_of_targets }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-shrink-0 h-20 px-4 py-3",
                                style: { width: "50%" },
                                attrs: { title: curriculum.description }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass:
                                    "whitespace-pre-line line-clamp-2 h-13",
                                  attrs: { text: curriculum.description }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.totalCurriculums > 25
                    ? _c("BlInputPagination", {
                        attrs: {
                          page: _vm.page,
                          perPage: _vm.perPage,
                          total: _vm.totalCurriculums
                        },
                        on: {
                          changed: _vm.changePage,
                          "changed-per-page": _vm.changePerPage
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "absolute z-10 transition-all duration-500",
              class: [
                _vm.checkedCurriculums.length > 0 ? "bottom-10" : "-bottom-100"
              ],
              style: { left: "calc((100% - 50rem) / 2)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-between h-16 px-6 border rounded shadow-md bg-pure-white border-slate-400",
                  style: { width: "calc(50rem)" }
                },
                [
                  _c(
                    "div",
                    [
                      _vm.checkedCurriculums.length > 1
                        ? _c("BlTextSubtitle3", {
                            attrs: {
                              text:
                                _vm.checkedCurriculums.length +
                                " curricula selected"
                            }
                          })
                        : _c("BlTextSubtitle3", {
                            attrs: {
                              text:
                                _vm.checkedCurriculums.length +
                                " curriculum selected"
                            }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          label: "Deselect all",
                          type: "outlined",
                          dense: ""
                        },
                        on: {
                          clicked: function($event) {
                            _vm.checkedCurriculums = []
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.checkedCurriculums.length > 1
                        ? _c("BlInputButton", {
                            attrs: {
                              label:
                                "Add " +
                                _vm.checkedCurriculums.length +
                                " curricula",
                              dense: ""
                            },
                            on: { clicked: _vm.onAddCheckedCurriculums }
                          })
                        : _c("BlInputButton", {
                            attrs: {
                              label:
                                "Add " +
                                _vm.checkedCurriculums.length +
                                " curriculum",
                              dense: ""
                            },
                            on: { clicked: _vm.onAddCheckedCurriculums }
                          })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative flex-shrink-0 pb-32 overflow-y-auto border w-92 bg-pure-white border-slate-400",
          style: { height: "calc(100vh - 14rem)" },
          attrs: { id: "bulk-selected" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky top-0 z-10 flex flex-col gap-1 px-6 py-5 border-b bg-pure-white border-slate-400"
            },
            [
              _c("BlTextSubtitle1", {
                attrs: { text: "List of selected targets" }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text:
                    "Here is a list of targets you've selected by curricula to be added for the client."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.selectedCurriculums.length
            ? _c(
                "div",
                { staticClass: "grid h-64 place-items-center" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "No curriculum has been added yet." }
                  })
                ],
                1
              )
            : _vm._l(_vm.selectedCurriculums, function(curriculum) {
                return _c("div", { key: curriculum.id }, [
                  _c("div", { staticClass: "flex w-full bg-slate-200" }, [
                    _c("div", {
                      staticClass: "w-1.5 flex-shrink-0",
                      style: { backgroundColor: curriculum.color }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-between w-full gap-3 px-6 py-4 border-b border-slate-400"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-1 truncate" },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "truncate",
                              attrs: {
                                text: curriculum.name,
                                title: curriculum.name
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "truncate text-slate-1000",
                              attrs: {
                                text:
                                  curriculum.number_of_targets + " target(s)"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center flex-shrink-0 gap-2"
                          },
                          [
                            _c("BlInputButton", {
                              attrs: {
                                type: "outlined-error",
                                dense: "",
                                icon: "delete"
                              },
                              on: {
                                clicked: function($event) {
                                  return _vm.$emit("remove", curriculum)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BlIcon", {
                              staticClass:
                                "w-4 h-4 transition-all duration-300",
                              style: _vm.idsClosed.includes(curriculum.id)
                                ? { rotate: "180deg" }
                                : {},
                              attrs: { icon: "chevron-up", clickable: "" },
                              on: {
                                clicked: function($event) {
                                  return _vm.onToggleChevron(curriculum.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.idsClosed.includes(curriculum.id)
                    ? _c(
                        "div",
                        _vm._l(curriculum.targets, function(target) {
                          return _c(
                            "div",
                            {
                              key: target.id,
                              staticClass:
                                "py-4 pl-7.5 pr-6 flex items-center justify-between gap-3 border-b border-slate-400"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-col gap-1 truncate" },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate text-slate-1000",
                                    attrs: {
                                      text: target.name,
                                      title: target.name
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text: _vm.targetTypes[target.type]
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4c9adb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4c9adb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/SelectTargetCurricula.vue
// module id = null
// module chunks = 